<template>
  <v-container fluid>
    <v-row>
      <v-col :cols="selectedIp ? 8 : 12">
        <RequestMap
            :selected-ip="selectedIp"
            @select="selectedIp = $event"
            @window="hours = $event"
        />
      </v-col>
      <v-col v-if="selectedIp" cols="4">
        <IpDetailPanel
            :ip="selectedIp"
            :hours="hours"
            @close="selectedIp = null"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <UsageStats
            :hours="hours"
            @select="selectedIp = $event"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RequestMap from '../components/Monitor/RequestMap'
import IpDetailPanel from '../components/Monitor/IpDetailPanel'
import UsageStats from '../components/Monitor/UsageStats'

export default {
  name: 'Monitor',
  components: { RequestMap, IpDetailPanel, UsageStats },
  data() {
    return {
      // Karte und Panel teilen sich das Zeitfenster: die Karte besitzt es und
      // meldet Änderungen hoch, das Panel liest es als Prop. Sonst zeigte das
      // Panel Zahlen aus einem anderen Zeitraum als die Karte.
      selectedIp: null,
      hours: 24,
    }
  },
}
</script>

<style scoped>

</style>
